import { createFileRoute } from "@tanstack/react-router";
import { AdminSettingsPage } from "../components/shop/admin-settings-page.tsx";

export const Route = createFileRoute("/produkter/installningar")({ component: AdminSettingsPage });
